import * as t from "io-ts";
export const meT = t.strict({
    firstName: t.string,
    lastName: t.string,
    searchOrigin: t.strict({
        lon: t.number,
        lat: t.number,
    }),
    hasApiAccess: t.boolean,
    canSeeOrdersDelivered: t.boolean,
});
//# sourceMappingURL=me.js.map